"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.define-property.js");

var _toConsumableArray2 = require("@babel/runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require("@babel/runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _optionProcessor = require("../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor");

var _optionProcessor2 = _interopRequireDefault(_optionProcessor);

var _core = require("@mpxjs/core");

var _props = require("../../model/props");

var _webxJs = require("@didi/webx-js");

function _interopRequireDefault(obj) {
    try {
        return obj && obj.__esModule ? obj : { default: obj };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_interopRequireDefault@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

function ownKeys(object, enumerableOnly) {
    try {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function func_trir_e6f9dcb162ddc91bed10b034c2858b85(sym) {
                try {
                    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_e6f9dcb162ddc91bed10b034c2858b85@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('ownKeys@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

function _objectSpread(target) {
    try {
        for (var i = 1; i < arguments.length; i++) {
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), !0).forEach(function func_trir_c0676a94f483fe5106ed726722866000(key) {
                try {
                    (0, _defineProperty3.default)(target, key, source[key]);
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_c0676a94f483fe5106ed726722866000@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function func_trir_b76604ff2c09d1b25f9e26fd3e3dbe8a(key) {
                try {
                    Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_b76604ff2c09d1b25f9e26fd3e3dbe8a@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            });
        }
        return target;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_objectSpread@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var wxsModules = {};
global.currentSrcMode = "wx";

(0, _core.createComponent)({
  name: 'WebxChannelGift',
  properties: _props.propsForView,
  computed: {
    backgroundImage: function backgroundImage() {
    try {
        return this.pageConfig.background_image || '';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('backgroundImage@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    backgroundColor: function backgroundColor() {
    try {
        return this.pageConfig.background_color || '';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('backgroundColor@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    backgroundStyle: function backgroundStyle() {
    try {
        return {
            backgroundImage: 'url(\''.concat(this.backgroundImage, '\')'),
            backgroundColor: ''.concat(this.backgroundColor)
        };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('backgroundStyle@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    hotLine: function hotLine() {
    try {
        return this.pageConfig.hotline || '4000000999';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('hotLine@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    hotLineColor: function hotLineColor() {
    try {
        return this.pageConfig.hotline_color || '#FFFFFF';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('hotLineColor@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    coverTitle: function coverTitle() {
    try {
        return this.pageConfig.cover_title || '';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('coverTitle@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    coverLogoUrl: function coverLogoUrl() {
    try {
        return this.pageConfig.cover_logo || 'https://dpubstatic.udache.com/static/dpubimg/faf5e663-686b-4495-9e50-9996f923686e.png';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('coverLogoUrl@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    privacyPolicyType: function privacyPolicyType() {
    try {
        return 'text';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('privacyPolicyType@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    privacyPolicyDefaultStatus: function privacyPolicyDefaultStatus() {
    try {
        return false;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('privacyPolicyDefaultStatus@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    isAutoJump: function isAutoJump() {
    try {
        return this.pageConfig.auto_jump || false;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('isAutoJump@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    resultButtonConfig: function resultButtonConfig() {
    try {
        var defaultLink = this.isMiniprogram ? '/pages/index/index' : window.location.href;
        var config = {
            buttonType: this.pageConfig.result_button_type || 'share',
            buttonText: this.pageConfig.result_button_type === 'customize' ? this.pageConfig.result_button_text : '分享好友来领券',
            tipText: this.pageConfig.result_button_type === 'customize' ? this.pageConfig.result_tip_text : '',
            h5Link: this.pageConfig.result_button_h5_link || defaultLink,
            miniprogramType: this.pageConfig.result_button_miniprogram_type || 'didi',
            appId: this.pageConfig.result_button_miniprogram_appId || '',
            miniprogramLink: this.pageConfig.result_button_miniprogram_link || '/pages/index/index',
            fromPage: 'resultPage',
            isMainBtn: true
        };
        return config;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('resultButtonConfig@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    errorButtonConfig: function errorButtonConfig() {
    try {
        var defaultLink = this.isMiniprogram ? '/pages/index/index' : (0, _webxJs.xenv)() === 'passenger' ? 'https://v.didi.cn/jGM8qom' : 'https://didi.cn/q7nbOnj';
        var config = {
            buttonType: this.pageConfig.error_button_type || 'share',
            buttonText: this.pageConfig.error_button_type === 'customize' ? this.pageConfig.error_button_text : '领更多优惠',
            tipText: this.pageConfig.error_button_type === 'customize' ? this.pageConfig.error_tip_text : '福利中心更多优惠等你',
            h5Link: this.pageConfig.error_button_h5_link || defaultLink,
            miniprogramType: this.pageConfig.error_button_miniprogram_type || 'didi',
            appId: this.pageConfig.error_button_miniprogram_appId || '',
            miniprogramLink: this.pageConfig.error_button_miniprogram_link || '/pages/index/index',
            fromPage: 'errorPage',
            isMainBtn: true
        };
        return config;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('errorButtonConfig@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    showPreparePage: function showPreparePage() {
    try {
        return !this.loading && this.pageStatus === 1;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('showPreparePage@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    showSuccessPage: function showSuccessPage() {
    try {
        return !this.loading && this.pageStatus === 2;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('showSuccessPage@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    showPosterPage: function showPosterPage() {
    try {
        return !this.loading && this.pageStatus === 3;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('showPosterPage@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    showErrorPage: function showErrorPage() {
    try {
        return !this.loading && this.pageStatus === 4;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('showErrorPage@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    showPrivacyPolicyText: function showPrivacyPolicyText() {
    try {
        return this.showPreparePage && this.privacyPolicyType === 'text';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('showPrivacyPolicyText@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    showPrivacyPolicyCheck: function showPrivacyPolicyCheck() {
    try {
        return this.showPreparePage && this.privacyPolicyType === 'checkable';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('showPrivacyPolicyCheck@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    rules: function rules() {
    try {
        return this.pageConfig.activity_rules || '';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('rules@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    // 新客券列表
    newUserCouponList: function newUserCouponList() {
    try {
        var list = [];
        if (this.activityInfo.new_customer_info) {
            var didiCoupon = this.activityInfo.new_customer_info.coupon_info || [];
            didiCoupon = didiCoupon.map(function func_trir_08af757186cfa991bc64eacd7fcf3c59(coupon) {
                try {
                    return _objectSpread({ source_type: 'normal' }, coupon);
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_08af757186cfa991bc64eacd7fcf3c59@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            });
            var merchantCoupon = this.activityInfo.new_customer_info.ecom_info || [];
            merchantCoupon = merchantCoupon.map(function func_trir_02913f32148fb39327a517c7af8bb1b2(coupon) {
                try {
                    return _objectSpread({ source_type: 'merchant' }, coupon);
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_02913f32148fb39327a517c7af8bb1b2@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            });
            list = [].concat((0, _toConsumableArray3.default)(didiCoupon), (0, _toConsumableArray3.default)(merchantCoupon)).map(function func_trir_b82611e79cb6813fe2a8ab517872ea44(coupon) {
                try {
                    return _objectSpread({ is_new_user: true }, coupon);
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_b82611e79cb6813fe2a8ab517872ea44@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            });
        }
        return list;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('newUserCouponList@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    newUserCoupon: function newUserCoupon() {
    try {
        return this.newUserCouponList[0] || {};
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('newUserCoupon@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    errorInfo: function errorInfo() {
    try {
        return this.activityInfo.errorInfo || {};
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('errorInfo@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
  },
  methods: {
    handleAction: function handleAction(_ref) {
    try {
        var detail = _ref.detail;
        this.triggerEvent('action', detail);
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('handleAction@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    handleTrackEvent: function handleTrackEvent(_ref2) {
    try {
        var detail = _ref2.detail;
        this.triggerEvent('trackEvent', detail);
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('handleTrackEvent@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
  },
  data: function data() {
    try {
        return { isMiniprogram: __mpx_mode__ === 'wx' || __mpx_mode__ === 'ali' };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('data@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
  created: function created() {
},
  ready: function ready() {
}
});
var currentOption = global.currentOption;
exports.default = (0, _optionProcessor2.default)(currentOption, "component", "", "index7c39b0fb", {}, // @ts-ignore
{}, // @ts-ignore
{
  'prepare-page': function preparePage() {
    try {
        return import('./prepare-page.mpx?async=prepare&component=true&componentId=prepare-page4b622e3a').then(function func_trir_963828fbc1b3711a79441b787c8c0672(res) {
            try {
                return (0, _optionProcessor.getComponent)(res);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_963828fbc1b3711a79441b787c8c0672@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('preparePage@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
  'result-page': function resultPage() {
    try {
        return import('./result-page.mpx?async=result&component=true&componentId=result-page359e9e68').then(function func_trir_963828fbc1b3711a79441b787c8c0672(res) {
            try {
                return (0, _optionProcessor.getComponent)(res);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_963828fbc1b3711a79441b787c8c0672@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('resultPage@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
  'poster-page': function posterPage() {
    try {
        return import('./poster-page.mpx?async=poster&component=true&componentId=poster-page520c3f38').then(function func_trir_963828fbc1b3711a79441b787c8c0672(res) {
            try {
                return (0, _optionProcessor.getComponent)(res);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_963828fbc1b3711a79441b787c8c0672@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('posterPage@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
  'error-page': function errorPage() {
    try {
        return import('./error-page.mpx?async=error&component=true&componentId=error-page68ac19d9').then(function func_trir_963828fbc1b3711a79441b787c8c0672(res) {
            try {
                return (0, _optionProcessor.getComponent)(res);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_963828fbc1b3711a79441b787c8c0672@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('errorPage@@../../../../src/components/pages/index.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
  'rule-label': (0, _optionProcessor.getComponent)(require("../common/rule-label.mpx?component=true&componentId=rule-label75fab80a")),
  'privacy-policy': (0, _optionProcessor.getComponent)(require("../common/privacy-policy.mpx?component=true&componentId=privacy-policy31203faf")),
  'consumer-hotline': (0, _optionProcessor.getComponent)(require("../common/consumer-hotline.mpx?component=true&componentId=consumer-hotline58371c7c")),
  'rule-modal': (0, _optionProcessor.getComponent)(require("../common/rule-modal.mpx?component=true&componentId=rule-modal6a909b34")),
  'loading-modal': (0, _optionProcessor.getComponent)(require("../common/loading-modal.mpx?component=true&componentId=loading-modal305c6732"))
}, undefined, {}, undefined, (0, _optionProcessor.getWxsMixin)(wxsModules));